import { TextParameter } from '@drivingdoc/shared-types/reports';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { Controller, useFormContext } from 'react-hook-form';

interface TextParameterFieldProps {
  parameter: TextParameter;
}

export default function TextParameterField({ parameter }: TextParameterFieldProps) {
  const { control } = useFormContext();
  const { config } = parameter;

  return (
    <Grid size={12}>
      <Controller
        name={parameter.name}
        control={control}
        defaultValue={config?.defaultValue ?? ''}
        rules={{
          pattern: config?.pattern
            ? {
                value: new RegExp(config.pattern),
                message: config.patternMessage ?? 'Invalid format',
              }
            : undefined,
        }}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            fullWidth
            multiline={config?.multiline}
            rows={config?.multiline ? 3 : undefined}
            label={parameter.label}
            required={parameter.required}
            placeholder={config?.placeholder}
            error={!!fieldState.error}
            helperText={fieldState.error?.message ?? parameter.helpText}
            slotProps={{
              htmlInput: {
                minLength: config?.minLength,
                maxLength: config?.maxLength,
              },
            }}
          />
        )}
      />
    </Grid>
  );
}
